import React, { FC, PropsWithChildren } from 'react';
import { WixDesignSystemProvider } from '@wix/design-system';

import App from './App';
import { ExperimentsProvider } from '../../contexts/ExperimentsContext';
import { useIsStudio2Ui } from '../../hooks/useIsStudio2Ui';
import { TemplatesPageUIProvider } from '../../contexts/TemplatesPageUIContext';

const DesignSystemProvider: FC<PropsWithChildren> = ({ children }) => {
  // contextClassName carries the theme to portals (popovers, modals)
  const themeClassName = useIsStudio2Ui() ? 'harmony-theme' : undefined;

  return (
    <WixDesignSystemProvider
      features={{ newColorsBranding: true }}
      theme={themeClassName ? { className: themeClassName } : undefined}
      contextClassName={themeClassName}
    >
      {children}
    </WixDesignSystemProvider>
  );
};

export default (props: any) => {
  return (
    <ExperimentsProvider>
      <DesignSystemProvider>
        <TemplatesPageUIProvider>
          <App {...props} />
        </TemplatesPageUIProvider>
      </DesignSystemProvider>
    </ExperimentsProvider>
  );
};
